import Skeleton from '../shared/Skeleton'

/**
 * Exact-layout placeholder for `OrderCard` (RP-5936 prototype geometry): the
 * 90×108 (md: 130×156) image tile and the matching `min-h` on the text
 * column fix the row height, so the swap to content causes no layout shift.
 */
export function OrderCardSkeleton() {
  return (
    <div
      className="flex w-full items-center gap-16 bg-white"
      data-testid="order-card-skeleton"
    >
      <Skeleton
        r={4}
        className="w-[90px] h-[108px] md:w-[130px] md:h-[156px] shrink-0"
      />
      <div className="flex min-h-[108px] md:min-h-[156px] flex-1 flex-col justify-center gap-10">
        <Skeleton h={16} className="w-[56%]" />
        <Skeleton h={12} className="w-[72%]" />
      </div>
    </div>
  )
}
